import { render, staticRenderFns } from "./DatePickerLegacy.vue?vue&type=template&id=00a40dce&"
import script from "./DatePickerLegacy.vue?vue&type=script&lang=js&"
export * from "./DatePickerLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports